module.exports = __webpack_public_path__ + "static/media/Gradient_Client_Page_(optimized)2.15d38fa5.png";